import { render, staticRenderFns } from "./PackingTaskCard.vue?vue&type=template&id=0d84ed19&scoped=true&"
import script from "./PackingTaskCard.vue?vue&type=script&lang=js&"
export * from "./PackingTaskCard.vue?vue&type=script&lang=js&"
import style0 from "./PackingTaskCard.vue?vue&type=style&index=0&id=0d84ed19&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d84ed19",
  null
  
)

export default component.exports